import(/* webpackMode: "eager" */ "C:\\Users\\VICTOR\\Desktop\\workspace_01\\rotalounge\\rotalounge_lp\\app\\(default)\\layout.tsx")